import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner({ message = 'Loading', inline = false }) {
  if (inline) {
    return (
      <div className="spinner-container--inline">
        <div className="spinner spinner--sm">
          <div className="spinner1 spinner1--sm" />
        </div>
        {message && <p className="spinner-message spinner-message--sm">{message}</p>}
      </div>
    );
  }
  return (
    <div className="spinner-container">
      <div className="spinner">
        <div className="spinner1" />
      </div>
      {message && <p className="spinner-message">{message}</p>}
    </div>
  );
}

export default LoadingSpinner;
